import { type SyntheticEvent, type KeyboardEvent } from 'react';

const EVENT_KEYS = new Set(['Enter', ' ']);
export const handleEnterOrSpace = (callback?: (event: SyntheticEvent) => void) => (event: KeyboardEvent<Element>) => {
  if (EVENT_KEYS.has(event.key) && callback) {
    callback(event);

    event.preventDefault();
    event.stopPropagation();
  }
};

export const handleEnter = (callback: (event: KeyboardEvent<HTMLInputElement>) => void) => (event: KeyboardEvent<HTMLInputElement>) => {
  if (event.key === 'Enter') {
    callback(event);

    event.preventDefault();
    event.stopPropagation();
  }
};
